document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth > 749) return;

  function strikethrough(text) {
    return text.split('').map(function(c) { return c + '\u0336'; }).join('');
  }

  var variantData = [];
  document.querySelectorAll('script[type="application/json"]').forEach(function(s) {
    if (s.textContent.includes('"available"') && s.textContent.includes('"title"')) {
      try { variantData = JSON.parse(s.textContent); } catch(e) {}
    }
  });

  document.querySelectorAll('fieldset.product-form__input.btn--secondary').forEach(function (fieldset) {
    var inputs = fieldset.querySelectorAll('input[type="radio"]');
    if (inputs.length < 7) return;

    var legend = fieldset.querySelector('legend');

    var label = document.createElement('p');
    label.textContent = 'Kies je afmeting:';
    label.style.marginBottom = '6px';
    label.style.marginTop = '0';
    label.style.fontWeight = '600';
    label.style.fontSize = '14px';

    var select = document.createElement('select');
    select.className = 'select__select mobile-variant-select';
    select.style.width = '100%';
    select.style.padding = '12px 16px';
    select.style.fontSize = '14px';
    select.style.fontFamily = 'inherit';
    select.style.border = '1px solid #e0e0e0';
    select.style.borderRadius = '4px';
    select.style.backgroundColor = '#ffffff';
    select.style.color = 'inherit';
    select.style.cursor = 'pointer';
    select.style.display = 'block';

    inputs.forEach(function (input) {
      var variant = variantData.find(function(v) { return v.title === input.value; });
      var available = variant ? variant.available : true;
      var option = document.createElement('option');
      option.value = input.value;
      if (available) {
        option.textContent = input.value;
      } else {
        option.textContent = strikethrough(input.value) + ' — uitverkocht';
        option.style.color = '#999';
      }
      if (input.checked) option.selected = true;
      select.appendChild(option);
    });

    select.addEventListener('change', function () {
      var matchingInput = fieldset.querySelector('input[value="' + this.value + '"]');
      if (matchingInput) matchingInput.click();
    });

    fieldset.querySelectorAll('.product-form__item').forEach(function (item) {
      item.style.display = 'none';
    });

    if (legend) legend.style.display = 'none';

    fieldset.prepend(select);
    fieldset.prepend(label);
  });
});
